import { listarTurnosPorCliente } from '../services/turneroService';
import { apellidoNombre } from './nombrePersona';

/**
 * Turno del que "vuelve" un cliente elegido del padrón (no de los atendidos de hoy): su atención
 * FINALIZADA más reciente, de cualquier día. Los trámites exprés no cuentan, porque no fueron una
 * atención. El backend devuelve el historial del más nuevo al más viejo.
 *
 * Rechaza con un Error de mensaje legible si no hay ninguna: ese cliente no "vuelve", llega sin
 * turno.
 */
export async function ultimaAtencionFinalizada(cliente) {
    const turnos = await listarTurnosPorCliente(cliente?.cuil);
    const ultimo = turnos.find((t) => t?.estado === 'FINALIZADO' && !t?.esTramiteExpres);
    if (!ultimo) {
        const nombre = apellidoNombre(cliente?.apellido, cliente?.nombre) || 'Este cliente';
        throw new Error(`${nombre} no tiene atenciones finalizadas a las que volver. Registralo con "Llegó cliente sin turno".`);
    }
    return ultimo;
}
